import { createContext, useContext } from 'react';

// Default config — used when no tenant weddingId is in the URL, or while
// the tenant config is loading. Mirrors the existing hardcoded values so the
// live app at '/' continues to behave identically until data migration runs.
export const DEFAULT_TENANT_CONFIG = {
  weddingId: null,
  appName: 'The Sapling',
  coupleNames: 'The Couple',
  adminCode: 'MONKLUNA2026',

  theme: {
    primaryColor: '#930df2',
    darkBg: '#1b1022',
    lightBg: '#f7f5f8',
    fontKey: 'plus-jakarta-sans',
    fontBodyKey: 'plus-jakarta-sans',
    icon: 'eco',
    cursiveHeroName: false,  // true → name renders in Allison script; false → display font
    colorMode: null,        // null = user-controlled toggle; 'light' | 'dark' = tenant-locked
    heroImageUrl: null,     // null = decorative icon hero; URL string = full-bleed photo hero
    heroIcon: null,         // icon shown in icon-mode hero; null = falls back to theme.icon
    motifIcon: 'celebration',
    motifText: 'Welcome to our Celebration',
    amenitiesLabel: 'Around the Resort',
  },

  events: {
    multiDay: true,
    screenTitle: 'Events',
    cursiveDayHeaders: false,
    listView: false,  // true = scrollable grouped list (ignores tabs); false = tabbed day view
  },

  leaderboard: {
    layout: 'default',         // 'default' = flat list; 'podium' = #1 featured, #2-3 podium, rest list
    emptyIcon: 'emoji_events', // material symbol shown in empty state
    emptyTitle: 'No scores yet',
    emptySubtitle: 'Play games to get on the leaderboard',
    boardIcon: 'emoji_events', // icon next to board list title
    boardTitle: 'Rankings',    // title above the ranked list
  },

  settings: {
    showRoomNumber: false,
    showNotificationsToggle: false,  // placeholder UI only — FCM not yet wired
    showDarkModeToggle: true,
  },

  eventTags: ['General', 'Welcome Night', 'Haldi', 'Sangeet', 'Wedding', 'Reception'],

  rankTitles: [
    { maxRank: 1,   title: 'Purple Wisteria' },
    { maxRank: 2,   title: 'Royal Palm' },
    { maxRank: 3,   title: 'Giant Sequoia' },
    { maxRank: 4,   title: 'Great Banyan' },
    { maxRank: 5,   title: 'Young Tree' },
    { maxRank: 10,  title: 'The Sapling' },
    { maxRank: null, title: 'Seedling' },
  ],

  games: {
    predictions: {
      title: 'Wedding Predictions',  // sapling-2026 overrides to 'Bali-Market' in Firestore
    },
  },

  features: {
    predictions: true,
    hive: true,
    trivia: true,
    sapLinks: true,
    scavengerHunt: true,
    assassins: false,
  },

  story: {
    enabled: true,
    label: 'About the Story',
    format: 'poem',  // keeps the existing SaplingPoem behaviour as the default
  },

  active: true,
};

const TenantContext = createContext(DEFAULT_TENANT_CONFIG);

export const useTenant = () => useContext(TenantContext);

export default TenantContext;
